import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Checkbox from "@mui/material/Checkbox";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import FormControl from "@mui/material/FormControl";
import FormControlLabel from "@mui/material/FormControlLabel";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import TextField from "@mui/material/TextField";
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import {
  AUTH_SIGNUP_URL,
  DEPARTMETNS_URL,
  ORG_TITLE_URL,
  ORG_URL,
  USERS_URL,
} from "../../../Constants/Constants";
import AxiosInstance from "../../../services/AxiosInstance";
import { ThemeProvider } from "../../v2/home/theme/ThemeProvider";
import { useAlert } from "./../../alerts/AlertContext";
import AddTaskIcon from "@mui/icons-material/AddTask";
import IconButton from "@mui/material/IconButton";
import Tooltip from "@mui/material/Tooltip";

function UserDialog({ editUserId, selectedUserId, callUsers, isEdit }) {
  const [open, setOpen] = React.useState(false);
  const [userId, setUserId] = useState("");
  const [password, setPassword] = useState("");
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [displayName, setDisplayName] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");

  const [active, setActive] = useState(true);
  const [loginName, setLoginName] = useState("");
  const [empId, setEmpId] = useState("");

  const [orgRoleId, setOrgRoleId] = useState();
  const [organizationTitles, setOrganizationTitles] = useState([]);

  const [organizationId, setOrganizationId] = useState();
  const [organizations, setOrganizations] = useState([]);

  const [departmentId, setDepartmentId] = useState();
  const [departments, setDepartments] = useState([]);

  const showAlert = useAlert();

  useEffect(() => {
    getOrgs();
    getDepartments();
    getOrgsRoles();
  }, []);

  const handleSave = () => {
    const payload = {};
    payload.id = loginName;
    payload.password = loginName + "@" + empId;
    payload.firstName = firstName;
    payload.lastName = lastName;
    payload.name = displayName;
    payload.email = email;
    payload.phone = phone;
    payload.organization = { id: organizationId };
    payload.active = active;
    payload.organizationTitle = { id: orgRoleId };
    payload.empId = empId;
    payload.department = { id: departmentId };

    if (isEdit) {
      updateUser(payload);
    } else {
      saveUser(payload);
    }
  };

  const saveUser = (payload) => {
    AxiosInstance.post(AUTH_SIGNUP_URL, payload)
      .then((response) => {
        showAlert("User created successfully!", "success");
        callUsers();
      })
      .catch((error) => {
        showAlert("User creation failed!", "error");
        console.error(error);
      });

  }

  const updateUser = (payload) => {
    AxiosInstance.put(`${USERS_URL}/${loginName}`, payload)
      .then((response) => {
        showAlert("User updated successfully!", "success");
        callUsers();
      })
      .catch((error) => {
        showAlert("User updation failed!", "error");
        console.error(error);
      });
  }

  const handleClickOpen = () => {
    if (isEdit) {
      getUser();
    } else {
      setOpen(true);
    }
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleFirstNameChange = (event) => {
    setFirstName(event.target.value);
  };

  const handleLastNameChange = (event) => {
    setLastName(event.target.value);
  };

  const handleDisplayNameChange = (event) => {
    setDisplayName(event.target.value);
  };

  const handleLoginNameChange = (event) => {
    setLoginName(event.target.value);
  };
  const handleEmailChange = (event) => {
    setEmail(event.target.value);
  };

  const handleOrgRoleChange = (event) => {
    setOrgRoleId(event.target.value);
  };

  const handleOrgChange = (event) => {
    setOrganizationId(event.target.value);
  };

  const handleDeptChange = (event) => {
    setDepartmentId(event.target.value);
  };

  const handlePhoneChange = (event) => {
    setPhone(event.target.value);
  };

  const handleEmpIdChange = (event) => {
    setEmpId(event.target.value);
  };

  const handleStatusCheckedChange = (event) => {
    setActive(event.target.checked);
  };

  const getOrgs = () => {
    AxiosInstance.get(ORG_URL).then((response) =>
      setOrganizations(response.data.data)
    );
  };

  const getDepartments = () => {
    AxiosInstance.get(DEPARTMETNS_URL).then((response) =>
      setDepartments(response.data.data)
    );
  };

  const getOrgsRoles = () => {
    AxiosInstance.get(ORG_TITLE_URL).then((response) =>
      setOrganizationTitles(response.data.data)
    );
  };

  const getUser = () => {
    AxiosInstance.get(`${USERS_URL}/${encodeURIComponent(editUserId)}`).then((response) => {
      var userData = response.data.data;
      setLastName(userData.lastName);
      setFirstName(userData.firstName);
      setDisplayName(userData.name);
      setEmail(userData.email);
      setPhone(userData.phone);
      setOrganizationId(userData.organization.id);
      setActive(userData.active);
      setOrgRoleId(userData.organizationTitle.id);
      setEmpId(userData.empId);
      setLoginName(userData.id);
      setDepartmentId(userData?.department?.id);
      setOpen(true);
    });
  };

  return (
    <ThemeProvider>
      <React.Fragment>
        {isEdit === false ? (
          <>
            < Tooltip
              title="Add User"
              onClick={handleClickOpen}
              style={{ cursor: "pointer", margin: "2px", float: "right" }}
            >
              <IconButton>
                <AddTaskIcon color="primary" />
              </IconButton>
            </Tooltip>
          </>
        ) : (
          <Link onClick={handleClickOpen}>{selectedUserId}</Link>
        )
        }

        <Dialog
          open={open}
          onClose={handleClose}
          PaperProps={{
            component: "form",
            onSubmit: (event) => {
              event.preventDefault();

              handleSave();
              handleClose();
            },
          }}
        >
          <DialogTitle>Add User</DialogTitle>
          <DialogContent>
            <Box
              component="form"
              sx={{ "& .MuiTextField-root": { m: 1 } }}
              noValidate
              autoComplete="off"
            >
              <TextField
                autoFocus
                required
                margin="dense"
                id="Org"
                name="firstName"
                label="First Name"
                type="text"
                fullWidth
                variant="outlined"
                value={firstName}
                onChange={handleFirstNameChange}
              />

              <TextField
                autoFocus
                required
                margin="dense"
                id="Org"
                name="lastName"
                label="Last Name"
                type="text"
                fullWidth
                variant="outlined"
                value={lastName}
                onChange={handleLastNameChange}
              />
              <br />
              <TextField
                autoFocus
                required
                margin="dense"
                id="Org"
                name="displayName"
                label="Display Name"
                type="text"
                fullWidth
                variant="outlined"
                value={displayName}
                onChange={handleDisplayNameChange}
              />

              <TextField
                autoFocus
                required
                margin="dense"
                id="Org"
                name="emailAddress"
                label="Email Address"
                type="text"
                fullWidth
                variant="outlined"
                value={email}
                onChange={handleEmailChange}
              />
              <TextField
                autoFocus
                required
                margin="dense"
                id="Org"
                name="phone"
                label="Contact No"
                type="text"
                fullWidth
                variant="outlined"
                value={phone}
                onChange={handlePhoneChange}
              />
              <br />
              <FormControl variant="outlined" sx={{ m: 1, minWidth: 200 }}>
                <InputLabel id="demo-simple-select-standard-label">
                  Orgnization
                </InputLabel>
                <Select
                  labelId="demo-simple-select-standard-label"
                  id="demo-simple-select-standard"
                  value={organizationId}
                  onChange={handleOrgChange}
                  label="Orgnization"
                >
                  <MenuItem value="">
                    {" "}
                    <em>None </em>{" "}
                  </MenuItem>
                  {organizations.map((org) => (
                    <MenuItem value={org.id}>{org.name}</MenuItem>
                  ))}
                </Select>
              </FormControl>
              <FormControl variant="outlined" sx={{ m: 1, minWidth: 200 }}>
                <InputLabel id="demo-simple-select-standard-label">
                  Department
                </InputLabel>
                <Select
                  labelId="demo-simple-select-standard-label"
                  id="demo-simple-select-standard"
                  value={departmentId}
                  onChange={handleDeptChange}
                  label="Department"
                >
                  <MenuItem value="">
                    {" "}
                    <em>None </em>{" "}
                  </MenuItem>
                  {departments.map((dep) => (
                    <MenuItem value={dep.id}>{dep.name}</MenuItem>
                  ))}
                </Select>
              </FormControl>
              <br />
              <FormControl variant="outlined" sx={{ m: 1, minWidth: 200 }}>
                <InputLabel id="demo-simple-select-standard-label">
                  Orgnization Role
                </InputLabel>
                <Select
                  labelId="demo-simple-select-standard-label"
                  id="demo-simple-select-standard"
                  value={orgRoleId}
                  onChange={handleOrgRoleChange}
                  label="Orgnization Role"
                >
                  <MenuItem value="">
                    {" "}
                    <em>None </em>{" "}
                  </MenuItem>
                  {organizationTitles.map((role) => (
                    <MenuItem value={role.id}>{role.name}</MenuItem>
                  ))}
                </Select>
              </FormControl>

              <FormControlLabel
                variant="outlined"
                checked={active}
                onChange={handleStatusCheckedChange}
                control={<Checkbox Checked />}
                sx={{
                  m: 1,
                  minWidth: 180,
                  verticalAlign: "bottom",
                  marginBottom: "auto",
                }}
                label="Active"
              />
              <br />
              <TextField
                autoFocus
                required
                margin="dense"
                id="LoginName"
                name="loginName"
                label="Login Name"
                type="text"
                fullWidth
                variant="outlined"
                onChange={handleLoginNameChange}
                disabled={isEdit}
                value={loginName}
              />
              <br />
              <TextField
                autoFocus
                required
                margin="dense"
                id="empId"
                name="empId"
                label="Emp Id"
                type="text"
                fullWidth
                variant="outlined"
                onChange={handleEmpIdChange}
                value={empId}
              />
            </Box>

            <div className="form-group form-inline"></div>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleClose}>Cancel</Button>
            <Button type="submit">Add </Button>
          </DialogActions>
        </Dialog>
      </React.Fragment >
    </ThemeProvider >
  );
}
export default UserDialog;
